import React from 'react';
// import { GlobalStyles } from "@/styles/GlobalStyles";
import { BrowserRouter } from 'react-router-dom';
import RoutesIndex from '@/routes';
import { GlobalStyles } from '@/styles/GlobalStyles';
import ThemeProvider from '@/components/ThemeProvider';
import ClientPortalApp from '@/pages/ClientPortal';
import { isClientPortalHost } from '@/utils/clientPortalHost';
import AppToasts from '@/components/AppToasts';
import AppErrorBoundary from '@/components/AppErrorBoundary';
import { CommunityDock } from '@/features/community/CommunityDock';

const App: React.FC = () => {
   // client.mysmartfi.ph = the buyer's BASIC portal (client sub-login):
   // same build, completely different surface — one device, simple words.
   if (isClientPortalHost()) {
      return (
         <AppErrorBoundary>
            <BrowserRouter>
               <GlobalStyles />
               <ThemeProvider>
                  <ClientPortalApp />
                  <AppToasts />
               </ThemeProvider>
            </BrowserRouter>
         </AppErrorBoundary>
      );
   }
   return (
      <AppErrorBoundary>
         <BrowserRouter>
            <GlobalStyles />
            <ThemeProvider>
               <RoutesIndex />
               {/* Community drawer: mounted once, so it survives page changes (SmartFi Desktop App.tsx). */}
               <CommunityDock />
            </ThemeProvider>
         </BrowserRouter>
      </AppErrorBoundary>
   );
};

export default App;
